
import { setRunsheetShiftTableLoading } from '@/entities/gridTables/slices/runsheetShiftTablesSlice'
import { updateRunsheetShiftTableState } from '@/entities/gridTables/thunks/updateRunsheetShiftTableState'
import { fetchRunsheets } from '@/entities/schedules'
import { optimiseShift } from '@/entities/schedules/thunks/optimiseShift'
import { showShiftOnMap } from '@/entities/widgetWindows/thunks/showShiftOnMap'
import { showShiftsOnGantt } from '@/entities/widgetWindows/thunks/showShiftsOnGantt'
import { MosaicAdditionalToolbar } from '@/shared/components'
import { MosaicToolbarMenuItem } from '@/shared/components/MosaicAdditionalToolbar/models/MosaicToolbarMenuItem'
import { useAppDispatch } from '@/shared/store'
import { faArrowDown19 } from '@fortawesome/pro-light-svg-icons'
import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons'

import { useRunsheetShiftTableContext } from './RunsheetShiftTableContext'

export type RunsheetShiftWindowToolbarProps = {
  //
}

export const RunsheetShiftWindowToolbar: React.FC<RunsheetShiftWindowToolbarProps> = () => {
  const { shiftId, runsheetId } = useRunsheetShiftTableContext()
  const dispatch = useAppDispatch()

  const setShiftLoadingState = (loadingState: boolean) => {
    // Set loading state
    dispatch(setRunsheetShiftTableLoading({ id: shiftId, isLoading: loadingState }))
  }

  const onResequence = async () => {
    setShiftLoadingState(true)
    await dispatch(optimiseShift({ shiftId }))
    await dispatch(fetchRunsheets({ runsheetIds: [runsheetId] }))
    await dispatch(updateRunsheetShiftTableState({ shiftId: shiftId }))
    setShiftLoadingState(false)
  }


  const onShowOnMap = () => {
    dispatch(showShiftOnMap({ shiftId }))
  }

  const onShowOnGantt = () => {
    dispatch(showShiftsOnGantt({ shiftIds: [shiftId] }))
  }

  const toolbarMenuItems: MosaicToolbarMenuItem[] = [
    { type: 'actionItem', icon: faArrowDown19, label: 'Resequence', onClick: onResequence },
    { type: 'actionItem', icon: faArrowUpRightFromSquare, label: 'Show on map', onClick: onShowOnMap },
    { type: 'actionItem', icon: faArrowUpRightFromSquare, label: 'Show on gantt', onClick: onShowOnGantt },
  ]

  return (
    <MosaicAdditionalToolbar
      toolbarMenuItems={toolbarMenuItems}
      averageMenuItemWidth={120}
    />
  )
}
